'use es6';

import { BetaButton } from './BetaButton';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const OptLoading = () => {
  return /*#__PURE__*/_jsx(BetaButton, {
    icon: "none",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      use: "on-dark"
    })
  });
};
export default OptLoading;